import React from 'react';
import Logo1x from '../../assets/images/logo.png';
import Logo2x from '../../assets/images/logo@2x.png';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as RT from '../../constants/Routing';
import * as Actions from '../../actions/User';
import * as ActionsApp from '../../actions/App';
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.state = {
      // 施設ユーザー名を格納
      name: this.currentUser.enterpriseName || '未設定',
      badge: 0
      // name : "〇〇"
    };
  }

  componentDidMount() {
    // this.props.User.isLoggedIn = localStorage.getItem("logged_in") ? true : false;
    // this.props.User.isSignedUp = localStorage.getItem("signed_up") ? true : false;
    // if(!this.props.User.isLoggedIn || !this.props.User.isSignedUp || !localStorage.getItem('current_user')){
    //   this.props.history.push(RT.SIGN_IN_PATH)
    // }
    // this.props.User.accessToken = localStorage.getItem("access_token")
    // console.log(this.state.name)
    // console.log(this.props.User)
    // console.log(this.state.name)
  }

  componentWillReceiveProps(props) {
    console.log('TCL: componentDidMount Component -> props', props);
    if (!this.props.App.loading) {
      console.log('TCL: Component -> props', props);
      this.setState({ badge: this.props.App.notification.length });
    }
  }

  _toTop = () => {
    this.props.history.push(RT.TOP_PATH);
  };

  _signOut = e => {
    e.preventDefault();
    localStorage.removeItem('logged_in');
    localStorage.removeItem('current_user');
    localStorage.removeItem('access_token');
    this.props.history.push(RT.SIGN_IN_PATH);
  };

  render = () => {
    return (
      <div className="header">
        <img
          src={Logo1x}
          srcSet={`${Logo1x} 1x,${Logo2x} 2x`}
          alt=""
          className="logo"
          onClick={this._toTop}
        ></img>

        <nav className="header-nav">
          <ul className="header-menu">
            <li>
              <a href="#">
                <i class="fas fa-bell"></i>
                <label>{this.state.badge}</label>
              </a>
            </li>
            <li>
              <span className="header-nav-link">{this.state.name}様</span>
            </li>
            <li>
              <Link to={RT.SETTING_INDEX_PATH} className="header-nav-link" onClick={this._signOut}>
                ログアウト
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(ActionsApp, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
